import { fmtUSD } from "@/lib/format";

export function BoostBackFace({ amount }) {
  return (
    <div
      data-testid="boost-back-face"
      aria-hidden="true"
      className="absolute inset-0 flex flex-col items-center justify-center rounded-xl bg-[#071016]"
      style={{ transform: "rotateY(180deg)", backfaceVisibility: "hidden", WebkitBackfaceVisibility: "hidden" }}
    >
      <div className="font-mono text-3xl font-black text-cyan-300">+{fmtUSD(amount)}</div>
      <div className="mt-1 text-[11px] font-bold tracking-[0.28em] text-cyan-100">BACKED</div>
    </div>
  );
}

export function BackedBadge({ amount, slug, tilted = false }) {
  return (
    <span
      data-testid={`backed-badge-${slug}`}
      className={tilted
        ? "climb-backed-card inline-flex flex-col items-center rounded-2xl border border-cyan-200/80 bg-[#06202a]/90 px-4 py-3 font-mono font-black text-cyan-100"
        : "mt-1 inline-flex items-center rounded-full border border-cyan-300/40 bg-cyan-400/10 px-2 py-0.5 font-mono text-[10px] font-bold tracking-wide text-cyan-200"}
    >
      <span className={tilted ? "text-2xl leading-none" : ""}>+{fmtUSD(amount)}</span>
      <span className={tilted ? "mt-1 text-[11px] tracking-[0.22em]" : ""}> BACKED</span>
    </span>
  );
}

export function ClimbDelta({ value, slug }) {
  const up = value > 0;
  const places = Math.abs(value);
  return (
    <span
      data-testid={`climb-delta-${slug}`}
      className={`climb-delta inline-flex items-center font-mono text-[10px] font-bold ${up ? "text-cyan-300" : "text-negative"}`}
      aria-label={up ? `Climbed ${places}` : `Dropped ${places}`}
    >
      {up ? "↑" : "↓"}{places}
    </span>
  );
}
